// SVG-friendly references to the theme tokens defined in index.css
export const palette = {
  paper: 'rgb(var(--paper))',
  surface: 'rgb(var(--surface))',
  ink: 'rgb(var(--ink))',
  muted: 'rgb(var(--muted))',
  faint: 'rgb(var(--faint))',
  hairline: 'rgb(var(--hairline))',
  accent: 'rgb(var(--accent))',
  accentSoft: 'rgb(var(--accent-soft))',
  placebo: 'rgb(var(--placebo))',
};

export const displayFont = '"Inter Tight", Inter, system-ui, sans-serif';
